// extracted by mini-css-extract-plugin
module.exports = {"myPic":"Navbar_myPic__1ZfbF","icons":"Navbar_icons__37TI2","menuItem":"Navbar_menuItem__1oIqD","hr":"Navbar_hr__29HDy"};